var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.gameViewId,{tag:"component",attrs:{"scores":_vm.scores.sound},on:{"finish:sound":_vm.onFinishSound,"finish:author":_vm.onFinishAuthor,"nextGame":_vm.onNextGame}})}
var staticRenderFns = []

export { render, staticRenderFns }